import { FC } from 'react';

import { Link } from '@inertiajs/react';
import { ChevronDown } from 'lucide-react';

import { Routes } from '../../models/routes';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/Avatar';
import { Button } from '../ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '../ui/Dropdown-Menu';

interface Props {
    currentUser: {
        nickname: string;
        email: string;
        avatar?: string;
    };
    newNotificationPresent?: boolean;
}

export const ProfileDropdown: FC<Props> = ({
    currentUser,
    newNotificationPresent,
}) => {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    className="hidden h-9 gap-2 px-3 hover:bg-accent md:flex"
                >
                    <div className="relative">
                        <Avatar className="h-7 w-7">
                            <AvatarImage
                                src={currentUser.avatar}
                                alt={currentUser.nickname}
                            />
                            <AvatarFallback className="text-xs">
                                {currentUser.nickname[0]}
                            </AvatarFallback>
                        </Avatar>
                        {newNotificationPresent && (
                            <span className="absolute -top-1 -right-1 h-3 w-3 animate-pulse rounded-full bg-yellow-400"></span>
                        )}
                    </div>
                    <div className="hidden text-left lg:block">
                        <p className="text-xs leading-none font-medium">
                            {currentUser.nickname}
                        </p>
                    </div>
                    <ChevronDown className="ml-1 h-3 w-3" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
                <Link
                    href={`${Routes.User}/${currentUser.nickname}`}
                    className="w-full"
                >
                    <div className="px-3 py-2">
                        <div className="hidden text-left lg:block">
                            <p className="text-sm font-medium">
                                {currentUser.nickname}
                            </p>
                        </div>
                    </div>
                </Link>
                <DropdownMenuSeparator />
                <DropdownMenuItem asChild>
                    <Link href={Routes.NewOffer} className="w-full">
                        Створити пропозицію
                    </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                    <Link href={Routes.Balance} className="w-full">
                        Баланс
                    </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                    <Link href={Routes.Offers} className="w-full">
                        Пропозиції
                    </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                    <Link
                        href={Routes.Sales}
                        className="flex w-full items-center justify-between"
                    >
                        Продажі
                        {newNotificationPresent && (
                            <span className="h-3 w-3 animate-pulse rounded-full bg-yellow-400"></span>
                        )}
                    </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                    <Link href={Routes.Purchases} className="w-full">
                        Покупки
                    </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                    <Link href={Routes.Wishlist} className="w-full">
                        Список бажаного
                    </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                    <Link href={Routes.Reviews} className="w-full">
                        Відгуки
                    </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                    <Link href={Routes.ProfileEdit} className="w-full">
                        Редагувати профіль
                    </Link>
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem className="text-red-600">
                    <Link
                        href={Routes.SignOut}
                        method="delete"
                        className="w-full cursor-pointer"
                    >
                        Вийти
                    </Link>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
